export default {
    name: 'workflowProductSearch',
    list: 'list',
    meta: 'meta',
    query: 'query',
    fetchId: 'fetchId',
    searchId: 'searchId',
    selectedProducts: 'selectedProducts',
};
